var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B21E1E",
    d: "M7.5.299a7.2 7.2 0 1 0 0 14.401A7.2 7.2 0 0 0 7.5.3Zm.718 10.568a1 1 0 0 1-.718.302 1 1 0 0 1-.387-.08 1.1 1.1 0 0 1-.33-.218 1.02 1.02 0 0 1 .32-1.657 1.02 1.02 0 0 1 1.412.935 1 1 0 0 1-.297.718M8.515 7.5a1.016 1.016 0 0 1-2.03 0V4.85a1.015 1.015 0 1 1 2.03 0z"
  })));
};
export default SvgError;